<div class="container">
  <div class="page-container">
    <div class="header-content">
      @if (templateId) {
        <h2>Manage Email Templates</h2>
      } @else {
        <h2>Create Email Template</h2>
      }
      <button (click)="saveTemplate()" [disabled]="!isValid()" color="primary" mat-flat-button>Save Template</button>
    </div>
    <div class="content">
      <div class="w-50-2">
        <form [formGroup]="templateForm" class="email-template-form">
          <mat-form-field class="w-100-1">
            <mat-label>Name</mat-label>
            <input formControlName="name" readonly matInput />
          </mat-form-field>
          <mat-form-field class="w-100-1">
            <mat-label>Description</mat-label>
            <input formControlName="description" matInput />
          </mat-form-field>
          <mat-form-field class="w-100-1">
            <mat-label>Default Subject</mat-label>
            <input formControlName="subject" matInput />
          </mat-form-field>
          <div class="available-sub-sections w-50-2">
            <mat-form-field class="w-100-1">
              <mat-label>Available Substitutions</mat-label>
              <mat-select (selectionChange)="addSub($event)" placeholder="Available Substitutions">
                <mat-option *ngFor="let availableSub of availableSubs" [value]="availableSub">
                  {{ availableSub }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="required-sub-section w-50-2">
            @for (requiredSub of template?.requiredSubstitution; track $index) {
              <mat-chip [ngClass]="hasSub(requiredSub) ? 'present-chip' : 'gray'">
                <fa-icon
                  matChipAvatar
                  [icon]="['fas', hasSub(requiredSub) ? 'circle-check' : 'circle-xmark']"
                  [ngClass]="hasSub(requiredSub) ? 'white' : 'gray'"></fa-icon>
                <span class="sub-name">{{ requiredSub }}</span>
              </mat-chip>
            }
          </div>
          <mat-form-field class="w-100-1">
            <mat-label>Template Body</mat-label>
            <textarea formControlName="body" matInput></textarea>
          </mat-form-field>
        </form>
      </div>
      <div class="w-50-2">
        <div class="preview-label">Preview</div>
        <iframe title="Email Templates" #templateFrame class="email-template-iframe" src="about:blank"></iframe>
      </div>
    </div>
  </div>
</div>

<fc-spinner [overlay]="true" [show]="false" name="email-templates-spinner"></fc-spinner>
